import React, { Component } from "react";
import Axios from "axios";
import { GET_BRANDS_URL } from "../../../configs";
import Loading from "../../helpers/loading";
import App from "../../App";
import { currentDomain } from "../../../configs/website";

/**
 * AutoBrandLoader Component
 * Automatically loads the brand if only one exists for the current domain
 * Keeps the URL at root (/) instead of redirecting to /brand-slug
 */
class AutoBrandLoader extends Component {
    state = {
        loading: true,
        brand: null,
    };

    componentDidMount() {
        this.loadBrand();
    }

    loadBrand = () => {
        // Get current domain from window.location (includes port if present)
        console.log('AutoBrandLoader - Loading brand for domain:', currentDomain);
        
        // Fetch all active brands filtered by domain
        Axios.get( GET_BRANDS_URL, {
            params: {
                domain: currentDomain
            },
            headers: {
                'X-Original-Host': currentDomain,
                'X-Forwarded-Host': currentDomain,
            }
        })
            .then((response) => {
                if (response.data.success) {
                    const brands = response.data.brands || [];
                    
                    console.log('AutoBrandLoader - Brands loaded:', brands.length, brands);
                    
                    if (brands.length === 1) {
                        // Only one brand - load it directly at root
                        console.log('AutoBrandLoader - Single brand found, loading:', brands[0].unique_id);
                        localStorage.setItem('lastVisitedBrand', brands[0].unique_id);
                        this.setState({
                            brand: brands[0],
                            loading: false,
                        });
                    } else if (brands.length === 0) {
                        // No brands - show empty state message
                        console.log('AutoBrandLoader - No brands found for domain:', currentDomain);
                        this.setState({
                            loading: false,
                            showBrandSelection: false,
                        });
                    } else {
                        // Multiple brands - automatically use the first one
                        // (Since each domain should only have one brand, this is a fallback)
                        console.log('AutoBrandLoader - Multiple brands found, using first:', brands[0].unique_id);
                        localStorage.setItem('lastVisitedBrand', brands[0].unique_id);
                        localStorage.setItem('singleBrandForDomain', brands[0].unique_id);
                        this.setState({
                            brand: brands[0],
                            loading: false,
                        });
                    }
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch((error) => {
                console.error("AutoBrandLoader - Error loading brands:", error);
                this.setState({ loading: false });
            });
    };

    render() {
        const { loading, brand } = this.state;

        if (loading) {
            return <Loading />;
        }

        // If we have a brand, store it and render App directly at root
        // This keeps the URL at / while loading the brand
        if (brand) {
            // Store brand slug so SingleStoreRouter can detect it
            localStorage.setItem('lastVisitedBrand', brand.unique_id);
            localStorage.setItem('singleBrandForDomain', brand.unique_id);
            
            // Render App component directly - it will detect the brand from localStorage
            // Create modified props to simulate having brandSlug in URL
            const modifiedProps = {
                ...this.props,
                match: {
                    ...this.props.match,
                    params: {
                        brandSlug: brand.unique_id
                    }
                }
            };
            
            return <App {...modifiedProps} key={`root-brand-${brand.unique_id}`} />;
        }

        // No brand found - show empty state
        return (
            <div style={{ padding: '2rem', textAlign: 'center' }}>
                <h2>No Brand Available</h2>
                <p>No brand is configured for this domain.</p>
            </div>
        );
    }
}

export default AutoBrandLoader;

